import { render, staticRenderFns } from "./FeedbackDialog.vue?vue&type=template&id=2626f514&scoped=true"
import script from "./FeedbackDialog.vue?vue&type=script&lang=js"
export * from "./FeedbackDialog.vue?vue&type=script&lang=js"
import style0 from "./FeedbackDialog.vue?vue&type=style&index=0&id=2626f514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2626f514",
  null
  
)

export default component.exports